<template>
  <div :class="s.container">
    <div :class="s.bg_container">
      <img :class="[s.dot_stars_pink_1, s.rotation_pattern]" src="/img/pages/choikulove/header/dot-star-pink-small.svg" alt="">
      <img :class="[s.dot_stars_green_1, s.rotation_pattern_reverse]" src="/img/pages/choikulove/header/dot-star-green.svg" alt="">
      <img :class="[s.dot_stars_yellow_1, s.rotation_pattern]" src="/img/pages/choikulove/header/dot-star-yellow-small.svg" alt="">
      <img :class="[s.dot_stars_yellow_2, s.rotation_pattern_reverse]" src="/img/pages/choikulove/header/dot-star-yellow.svg" alt="">
      <img :class="[s.dot_stars_yellow_3, s.rotation_pattern]" src="/img/pages/choikulove/header/dot-star-yellow.svg" alt="">
      <img :class="[s.dot_stars_pink_2, s.rotation_pattern_reverse]" src="/img/pages/choikulove/header/dot-star-pink-small.svg" alt="">
      <img :class="[s.dot_stars_green_2, s.rotation_pattern]" src="/img/pages/choikulove/header/dot-star-green.svg" alt="">
      <img :class="[s.dot_stars_yellow_4, s.rotation_pattern_reverse]" src="/img/pages/choikulove/header/dot-star-yellow-small.svg" alt="">
      <img :class="[s.dot_stars_pink_3, s.rotation_pattern]" src="/img/pages/choikulove/header/dot-star-pink.svg" alt="">
      <img :class="s.bg_stars" src="/img/pages/choikulove/header/bg-stars.svg" alt="">
    </div>
    <div :class="s.header">
      <img :class="s.header_title" src="/img/pages/choikulove/header/header-title.svg" alt="">
    </div>
    <div :class="s.about">
      <div :class="s.about_bg"></div>
      <div :class="s.about_content">
        <img :class="s.about_content_main" src="/img/pages/choikulove/about/about-main.svg" alt="">
        <img :class="s.about_content_main_bg_star" src="/img/pages/choikulove/about/back-star.svg" alt="">
        <img :class="s.about_content_main_bg_giza" src="/img/pages/choikulove/about/back-gizagiza.svg" alt="">

      </div>
    </div>
    <div :class="s.special_content">
      <img :class="s.special_content_title" src="/img/pages/choikulove/specialcontent/title.svg" alt="">
      <img id="movie" :class="s.guestTalk_subTitle" src="/img/pages/choikulove/specialcontent/subTitle-1.svg" alt="">
      <div :class="s.guestTalk_wrap">
        <div :class="[s.guestTalk_card]" v-for="item in videos" :key="item.id">
          <div :class="s.guestTalk_movie_wrap">
            <div
              :class="[s.guestTalk_movie, s.youtube]"
              v-html="item.iframe"
            />
            <!-- <img
              @click="startVideo(item.id)"
              :class="s.guestTalk_movie" :src="item.thumbnail" alt=""> -->
            <img :class="s.guestTalk_movie_frame" src="/img/effects/movie_frame.svg" alt="">
            <div :class="s.guestTalk_movie_title_wrap">
              <div :class="s.guestTalk_movie_title">
                ちょいくらぶ #{{ item.id }}
              </div>
              <div :class="s.guestTalk_movie_title_back"/>
            </div>
          </div>
          <div :class="[s.guestTalk_comment]">
            <div :class="[s.guestTalk_comment_text]" v-html="item.description"/>
          </div>
        </div>
      </div>
    </div>
    <div :class="s.guestIntro_wrap">
      <img :class="s.guestIntro_title" src="/img/pages/choikulove/specialcontent/subTitle-2.svg" alt="">
      <div :class="s.guestIntro_content_wrap">
        <div :class="s.guestIntro_item">
          <img :class="s.guestIntro_item_img" src="/img/pages/choikulove/specialcontent/guest-1.png" alt="">
          <div :class="s.guestIntro_item_name">石川翔鈴</div>
          <div :class="s.guestIntro_item_text_wrap">
            <div :class="s.guestIntro_item_text">
              2003年3月28日生まれ、北海道出身。<br>
              恋愛リアリティ番組への出演によりZ世代から支持を集める。俳優としてドラマでは『低体温男子になつかれました。』(25年)/『浅草ラスボスおばあちゃん』(25年)や、2024年公開初主演映画『鶴の里物語』などがある。
            </div>
            <div :class="s.guestIntro_item_links">
              <div :class="s.guestIntro_item_sns">
                <a :class="s.guestIntro_item_sns_link" href="https://www.instagram.com/karen__i328/">
                  <img src="/img/sns/icon_insta.png" alt="">
                </a>
                <a :class="s.guestIntro_item_sns_link" href="https://x.com/karen__i328">
                  <img src="/img/sns/icon_x.png" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div :class="s.guestIntro_item">
          <img :class="s.guestIntro_item_img" src="/img/pages/choikulove/specialcontent/guest-2.png" alt="">
          <div :class="s.guestIntro_item_name">谷田ラナ</div>
          <div :class="s.guestIntro_item_text_wrap">
            <div :class="s.guestIntro_item_text">
              2008年3月16日生まれ、三重県出身。<br>
              『Popteen』専属モデルでZ世代を中心に注目を集める17歳。TBS『サンデー・ジャポン』や東京ガールズコレクション、話題のショートドラマに多数出演するなど、多方面で活躍中。
            </div>
            <div :class="s.guestIntro_item_links">
              <div :class="s.guestIntro_item_sns">
                <a :class="s.guestIntro_item_sns_link" href="https://www.instagram.com/tanidalana_0316/">
                  <img src="/img/sns/icon_insta.png" alt="">
                </a>
                <a :class="s.guestIntro_item_sns_link" href="https://www.tiktok.com/@tanidalana_0316">
                  <img src="/img/sns/icon_tiktok.png" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
        <div :class="s.guestIntro_item">
          <img :class="s.guestIntro_item_img" src="/img/pages/choikulove/specialcontent/guest-3.png" alt="">
          <div :class="s.guestIntro_item_name">面髙ケンスケ</div>
          <div :class="s.guestIntro_item_text_wrap">
            <div :class="s.guestIntro_item_text">
              1999年9月9日生まれ、千葉県出身。<br>
              お笑いコンビ『香呑(かのん)』として活動中。<br>
              Netflixリアリティシリーズ「オフライン ラブ」に出演し、現在はCMやドラマなど様々な舞台で活躍中。<br>
              今、Z世代に注目のイケメンお笑い芸人です！
            </div>
            <div :class="s.guestIntro_item_links">
              <div :class="s.guestIntro_item_sns">
                <a :class="s.guestIntro_item_sns_link" href="https://www.instagram.com/longlong_potato/">
                  <img src="/img/sns/icon_insta.png" alt="">
                </a>
                <a :class="s.guestIntro_item_sns_link" href="https://x.com/rental_poteto">
                  <img src="/img/sns/icon_x.png" alt="">
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChoikuLove',
  data() {
    return {
      isPlayingVideoId: null,
      videos: [
        {
          id: 1,
          thumbnail: '/img/thumbnails/choikulove-1.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/l2O8alOZHpM?si=wP7qsdp-JTW-zySk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
          description: `
            <div class="position-relative">
              <span class="${this.s.guestTalk_comment_text_subtitle_bg}"></span>
              <span class="${this.s.guestTalk_comment_text_subtitle}">トークテーマ</span>
            </div>
            <img src="/img/pages/choikulove/specialcontent/talk-theme-1.svg" alt="">
            <!--
            <span class="${this.s.guestTalk_comment_text_item}">①最近考えが変わったこと、考えていることは？？</span>
            <span class="${this.s.guestTalk_comment_text_item}">②どんな高校生だった？</span>
            <span class="${this.s.guestTalk_comment_text_item}">③高校時代の思い出</span>
            -->
          `,
        },
        {
          id: 2,
          thumbnail: '/img/thumbnails/choikulove-2.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/0SN9HTuaJjs?si=3XkrGokbzBwi1s7b" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
          description: `
            <div class="position-relative">
              <span class="${this.s.guestTalk_comment_text_subtitle_bg}"></span>
              <span class="${this.s.guestTalk_comment_text_subtitle}">トークテーマ</span>
            </div>
            <img src="/img/pages/choikulove/specialcontent/talk-theme-2.svg" alt="">
            <!--
            <span class="${this.s.guestTalk_comment_text_item}">④お金の使い道を紹介してください</span>
            <span class="${this.s.guestTalk_comment_text_item}">⑤お金についての考え方は？</span>
            <span class="${this.s.guestTalk_comment_text_item}">⑥１００万円もらったらどうする？？</span>
            <span class="${this.s.guestTalk_comment_text_item}">⑦ちょいくせ未来予報発表！</span>
            -->
          `,
        },
        {
          id: 3,
          thumbnail: '/img/thumbnails/choikulove-3.jpg',
          iframe: `
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/HzXqDltf-dc?si=QoZoHc9uznUpQdoL" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
          `,
          description: `
            <div class="position-relative">
              <span class="${this.s.guestTalk_comment_text_subtitle_bg}"></span>
              <span class="${this.s.guestTalk_comment_text_subtitle}">トークテーマ</span>
            </div>
            <img src="/img/pages/choikulove/specialcontent/talk-theme-3.svg" alt="">
            <!--
            <span class="${this.s.guestTalk_comment_text_item}">⑧高校生のうちにやっておいた方がいいこと　トップ３</span>
            -->
          `,
        },
      ],
    };
  },
  methods: {
    startVideo(id) {
      // 新しい動画を再生
      this.isPlayingVideoId = id;
    },
  },
};
</script>

<style lang="scss" module="s">
.container {
  background-color: var(--primary-yellow);
  background-image: url(/img/pages/choikulove/bg-kv.svg);
  background-position: center -5vw;
  background-size: 110.572917vw 69.777457vw;
  background-repeat: no-repeat;
  background-image: none;
  text-align: center;
  position: relative;

  @include smView {
    background-size: 176.9166672vw 111.6439312vw;
  }
}

.bg_container {
  position: absolute;
  top: 0;
  width: 100vw;
  height: 19.614583%;
  z-index: 1;
  overflow: hidden;

  @include smView {
    width: 102.916667vw;
    height: 133.643931vw;
  }
}

.dot_stars_pink_1 {
  position: absolute;
  top: 10%;
  left: -6%;
  width: calc(289px / 1920px * 100vw);
  height: auto;
}

.dot_stars_green_1 {
  position: absolute;
  top: 14%;
  left: 3%;
  width: calc(394px / 1920px * 100vw);
  height: auto;
}

.dot_stars_yellow_1 {
  position: absolute;
  top: 6%;
  left: 18%;
  width: calc(244px / 1920px * 100vw);
  height: auto;
}

.dot_stars_yellow_2 {
  position: absolute;
  top: -7%;
  left: 34%;
  width: calc(393px / 1920px * 100vw);
  height: auto;
}

.dot_stars_yellow_3 {
  position: absolute;
  top: -2%;
  left: 71%;
  width: calc(525px / 1920px * 100vw);
  height: auto;
}

.dot_stars_pink_2 {
  position: absolute;
  top: 15%;
  left: 88%;
  width: calc(309px / 1920px * 100vw);
  height: auto;
}


.dot_stars_green_2 {
  position: absolute;
  top: 46%;
  left: 79%;
  width: calc(439px / 1920px * 100vw);
  height: auto;
}

.dot_stars_yellow_4 {
  position: absolute;
  top: 75%;
  left: 71%;
  width: calc(279px / 1920px * 100vw);
  height: auto;
}

.dot_stars_pink_3 {
  position: absolute;
  top: 61%;
  left: 3%;
  width: calc(548px / 1920px * 100vw);
  height: auto;
}

.rotation_pattern {
  animation: rotation 15s ease-in-out infinite;
  animation-delay: 0s;
}

.rotation_pattern_reverse {
  animation: rotationReverse 15s ease-in-out infinite;
  animation-delay: 7.5s;
}

@keyframes rotation {
  0% {transform: rotate(0deg);}
  40% {transform: rotate(360deg);}
  80% {transform: rotate(720deg);}
  100% {transform: rotate(720deg);}
}

@keyframes rotationReverse {
  0% {transform: rotate(0deg);}
  40% {transform: rotate(-360deg);}
  80% {transform: rotate(-720deg);}
  100% {transform: rotate(-720deg);}
}

.bg_stars {
  position: absolute;
  top: 19%;
  left: 0;
  width: 100%;
  height: 100%;
}

.header {
  text-align: center;
  position: relative;
  top: 3%;
  left: 0;
  right: 0;
  width: 100%;
  height: fit-content;
  z-index: 4;
  padding-top: 230px;

  @include mdView {
    padding-top: 150px;
  }

  @include smView {
    padding-top: 100px;
  }
}

.header_title {
  position: relative;
  width: calc(855/1920 * 100%);
  max-width: 855px;
  z-index: 3;


  @include smView {
    width: 85%;
  }
}


.about {
  position: relative;
  z-index: 3;
}

.about_bg {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 100%;
  max-height: 428px;
  height: calc(1143/1920 * 100%);
  z-index: 0;
  background-image: url('/img/pages/choikulove/about/kumo-pink.svg');
  background-position: center;
  background-repeat: repeat;
  background-size: auto 100%;
}

.about_content {
  position: relative;
  z-index: 1;
  margin: 0 auto;
}

.about_content_main {
  position: relative;
  max-width: 1143px;
  width: calc(1143/1920 * 100%);
  margin-top: -5vw;
  z-index: 2;

  @include smView {
    width: 85%;
  }
}

.about_content_main_bg_star {
  position: absolute;
  top: 17vw;
  left: 13%;
  width: 8vw;
  max-width: 126px;
  height: auto;
  z-index: 1;

  @include mdView {
    top: 30vw;
    left: 8%;
  }
}

.about_content_main_bg_giza {
  position: absolute;
  top: 18vw;
  right: 14%;
  width: 8vw;
  max-width: 190px;
  height: auto;
  z-index: 1;

  @include mdView {
    top: 25vw;
    right: 8%;
  }
}

.special_content {
  position: relative;
  background-image: url('/img/pages/choikulove/bg-dot-kumo.svg');
  background-size: min(39%, 750px) 96%;
  background-repeat: no-repeat;
  background-position: center;
  padding-bottom: calc(170/1920 * 100%);

  @include mdView {
    background-size: 50% 96%;
  }

  @include smView {
    background-size: 75% 100%;
  }
}

.special_content_title {
  position: relative;
  z-index: 4;
  width: calc(1481/1920 * 100%);
  max-width: 1481px;
  margin-top: -3vw;
  margin-bottom: 5vw;

  @include smView {
    width: 80%;
  }
}

.guestTalk_subTitle {
  position: relative;
  z-index: 4;
  width: calc(1130/1920 * 100%);
  max-width: 1130px;
  margin-bottom: 5vw;

  @include smView {
    width: 80%;
    margin-bottom: 15vw;
  }
}

.guestTalk_wrap {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5vw;
}

.guestTalk_card {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  width: 100%;

  @include mdView {
    align-items: center;
  }

  @include smView {
    flex-direction: column;
    width: 95%;
  }
}

.guestTalk_movie_wrap {
  position: relative;
  width: calc(1030/1920 * 100%);
  max-width: 1030px;
  max-height: 16383px;
  height: fit-content;
  z-index: 4;

  @include smView {
    width: 100%;
  }
}

.guestTalk_movie {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 89%;
  height: 83%;
  transform: translate(-50.55%, -51%);
  margin: 0 auto;
  &.youtube {
    z-index: 3;
  }
}

.guestTalk_movie_frame {
  position: relative;
  pointer-events: none;
  width: 100%;
  height: 100%;
  z-index: 4;
}

.guestTalk_comment {
  position: relative;
  background-image: url('/img/pages/choikulove/specialcontent/comment-frame.svg');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  z-index: 3;
  margin-left: -6%;
  width: clamp(455px, 32.3958333333%, 545px);
  aspect-ratio: 622/618;
  display: flex;
  align-items: center;
  justify-content: center;

  @include mdView {
    width: min(369px, 50%);
    margin-left: -7%;
  }

  @include smView {
    margin-left: 0;
    margin-right: -36vw;
    translate: 0 -10vw;
    width: max(290px, 60%);
  }
}

.guestTalk_movie_title_wrap {
  position: absolute;
  z-index: 5;
  top: 1.2%;
  left: 100%;
  translate: -18% 0;
  width: fit-content;
  height: auto;
  transform: rotate(-5deg);
  transform-origin: center;

  @include mdView {
    top: -3.5%;
    left: 0;
    translate: -3% -45%;
  }
}

.guestTalk_movie_title {
  position: relative;
  z-index: 5;
  font-size: 26px;
  font-weight: 700;
  line-height: 1.5;
  width: 100%;
  height: auto;
  background-color: var(--primary-green);
  border: 1px solid var(--primary-black);
  border-radius: 50px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 80px;
  white-space: nowrap;

  @include mdView {
    font-size: 20px;
    padding: 14px 40px;
  }
  @include smView {
    font-size: 15px;
    padding: 7px 20px;
  }
}

.guestTalk_movie_title_back {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 4;
  width: 100%;
  height: 100%;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  border-radius: 50px;

  @include smView {
    top: 5px;
    left: 5px;
  }
}

.guestTalk_comment_text {
  position: relative;
  z-index: 4;
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
  width: min(calc(100% - 100px * 2), 80%);
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-left: 6%;

  > span {
    display: block;
  }

  @include mdView {
    width: 60%;
    font-size: 15px;
    padding-left: 4%;
  }

  @include smView {
    font-size: max(13px, 2.5vw);
    padding-left: 0;
  }
}

.guestTalk_comment_text_subtitle {
  width: 200px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  margin-bottom: 30px;
  border-radius: 60px;
  background-color: var(--primary-pink);
  border: 1px solid var(--primary-black);
  position: relative;
  z-index: 2;

  @include mdView {
    padding: 4px 15px;
    font-size: 16px;
    width: 160px;
    height: 40px;
    margin-bottom: 20px;
  }

  @include smView {
    padding: 4px 15px;
    width: max(120px, 22vw);
    font-size: max(13px, 2.5vw);
    height:35px;
  }
}

.guestTalk_comment_text_subtitle_bg {
  position: absolute;
  content: '';
  width: 200px;
  height: 50px;
  background-color: var(--primary-yellow);
  border: 1px solid var(--primary-black);
  top: 4px;
  left: 4px;
  z-index: 1;
  border-radius: 60px;
  
  @include mdView {
    width: 160px;
    height: 40px;
  }

  @include smView {
    width: max(120px, 22vw);
    height: 35px;
  }
}

.guestTalk_card:nth-of-type(even) {
  flex-direction: row-reverse;

  @include smView {
    flex-direction: column;
  }

  .guestTalk_comment_text {
    padding-left: 0;
    padding-right: 4%;

    @include smView {
      padding-right: 0;
    }
  }

  .guestTalk_comment {
    margin-left: 0;
    margin-right: -100px;

    @include mdView {
      margin-right: -7%;
    }

    @include smView {
      margin-left: -36vw;
      margin-right: 0;
    }
  }

  .guestTalk_movie_title_wrap {
    top: -3.5%;
    left: unset;
    right: 100%;
    translate: 12% 0;
    transform: rotate(5deg);

    @include mdView {
      top: 0;
      left: 100%;
      right: unset;
      translate: -100% -67%;
    }

    @include smView {
      top: 0;
      right: 0;
      left: 100%;
      translate: -100% -67%;
    }
  }
}

.guestIntro_wrap {
  padding-inline: 3%;
  margin-top: 9%;

  @include smView {
    padding: 0;
  }
}

.guestIntro_title {
  z-index: 4;
  width: calc(1130/1920 * 100%);
  max-width: 1130px;
  margin-bottom: 5vw;

  @include smView {
    width: 80%;
  }
}

.guestIntro_content_wrap {
  display: flex;
  gap: 6px;
  padding-bottom: 150px;
  align-items: stretch;
  justify-content: center;

  @include smView {
    flex-direction: column;
    padding-bottom: 5vw;
    align-items: center;
  }
}

.guestIntro_item {
  position: relative;
  width:min( 33%, 373px);
  background-image: url('/img/pages/choikulove/specialcontent/guest-frame.svg');
  padding: 16px 16px 65px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @include mdView {
    gap: 10px;
  }

  @include smView {
    padding: 12px;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    width: 85%;
    gap: 10px;
  }
}

.guestIntro_item_img {
  width: 100%;
  height: auto;
  object-fit: contain;

  @include smView {
    width: 50%;
  }
}

.guestIntro_item_name {
  font-size: 36px;
  font-weight: 700;
  margin-top: 6px;
  margin-bottom: 25px;

  @include mdView {
    font-size: 24px;
  }

  @include smView {
    font-size: 18px;
    width: calc(100% - 10px - 50%);
    margin: 0;
  }
}

.guestIntro_item_text_wrap {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  height: 100%;

  @include smView {
    width: 100%;
  }
}

.guestIntro_item_text {
  font-size: 24px;
  line-height: 32px;
  letter-spacing: -0.4px;
  text-align: justify;

  @include mdView {
    font-size: 18px;
    line-height: normal;
  }

  @include smView {
    font-size: 12px;
    line-height: normal;
  }
}

.guestIntro_item_links {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;

  @include smView {
    gap: 8px;
    margin-top: 5px;
  }
}

.guestIntro_item_link {
  font-size: 26px;

  @include mdView {
    font-size: 16px;
  }
  @include smView {
    font-size: 12px;
  }
}

.guestIntro_item_sns {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
}

.guestIntro_item_sns_link {
  aspect-ratio: 1/1;
  width: 52px;
  object-fit: contain;

  @include mdView {
    width: 35px;
  }

  @include smView {
    width: 24px;
  }
}
</style>
